import { Injectable } from '@angular/core'
import { reactor } from '../reactor'
import { customerOperations } from '../stores/customer-store'
import IndustriesService from '../services/industries-service'
import { errorToast } from '../toaster'
import { donePromise } from '../utils'

@Injectable({providedIn: 'root'})
export class IndustryActions {
  industriesService = new IndustriesService();

  loadIndustries() {
    const p = this.industriesService.getAll().then(industries => {
      reactor.dispatch(customerOperations.setIndustries, industries)
    })
    .catch(() => {
      errorToast('Industries failed to load, please reload the page')
    })
    return donePromise(p)
  }
}
